import styled from 'styled-components';

export const StyledLoginInput = styled.input`
  max-width: 400px;
  width: 100%;
  padding-left: 12px;
  height: 50px;
  margin-bottom: 12px;
  font-size: 16px;
  border-radius: 8px;
  color: white;
  border: 1px solid white;
  background-color: transparent;

  &::placeholder {
    color: white;
  }

  @media (min-width: 500px) {
    height: 60px;
  }
` as any;
